/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRunAnalyticsResp
 */
export interface AdminRunAnalyticsResp {
    /**
     * ListingChecks is how many own eBay listings are queued for a check.
     * @type {number}
     * @memberof AdminRunAnalyticsResp
     */
    listingChecks: number;
    /**
     * NotInSale are requested products the analytics skips: not active, deleted or without live listings.
     * @type {number}
     * @memberof AdminRunAnalyticsResp
     */
    notInSale: number;
    /**
     * Products is how many of the requested products are in sale and queued.
     * @type {number}
     * @memberof AdminRunAnalyticsResp
     */
    products: number;
}

export function AdminRunAnalyticsRespFromJSON(json: any): AdminRunAnalyticsResp {
    return AdminRunAnalyticsRespFromJSONTyped(json, false);
}

export function AdminRunAnalyticsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRunAnalyticsResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'listingChecks': json['listingChecks'],
        'notInSale': json['notInSale'],
        'products': json['products'],
    };
}

export function AdminRunAnalyticsRespToJSON(value?: AdminRunAnalyticsResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'listingChecks': value.listingChecks,
        'notInSale': value.notInSale,
        'products': value.products,
    };
}

